/*
 * This is a modified version of the original 'ng-infinite-scroll' directive (v1.0.0 - 2013-02-23)
 * that works inside a parent container element (e.g. a div) and calculates values
 * relative to its own height.
 * To specify the 'container' behavior for the immediate parent, just add the 'infinite-scroll-parent' attribute.
 * For an arbitrary parent container, specify the 'infinite-scroll-container' attribute with a DOM selector or element.
 * In this case, 'scroll-distance' attribute accepts decimal values (< 1.0) and specifies how little
 * space below the scrollbar relative to the total element height should remain for the
 * handler to trigger.
 *
 * The original project location: https://github.com/sroze/ngInfiniteScroll
 *
 * *** License ***
 *
 * Copyright (c) 2012 Michelle Tilley
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */

var mod = angular.module('infinite-scroll', []);

mod.directive('infiniteScroll', [
  '$rootScope', '$window', '$timeout', '$parse', function($rootScope, $window, $timeout, $parse) {
    return {
      link: function(scope, elem, attrs) {

        $window = angular.element($window);

        var checkWhenEnabled, handler, scrollDistance, scrollEnabled, tempScrollTop = 0;

        var infiniteScrollContainer = $parse(attrs.infiniteScrollContainer)(scope);
        var containerElem = infiniteScrollContainer ? angular.element(infiniteScrollContainer) : elem;
        var useContainerElem = angular.isDefined(infiniteScrollContainer) || angular.isDefined(attrs.infiniteScrollParent);

        scrollDistance = 0;
        if (attrs.infiniteScrollDistance != null) {
          scope.$watch(attrs.infiniteScrollDistance, function(value) {
            return scrollDistance = useContainerElem ? parseFloat(value) : parseInt(value, 10);
          });
        }

        scrollEnabled    = true;
        checkWhenEnabled = false;
        if (attrs.infiniteScrollDisabled != null) {
          scope.$watch(attrs.infiniteScrollDisabled, function(value) {
            scrollEnabled = !value;
            if (scrollEnabled && checkWhenEnabled) {
              checkWhenEnabled = false;
              return handler();
            }
          });
        }

        handler = function() {

          var shouldScroll;

          if (useContainerElem) {
            // local behavior - calculate relative to container height
            var currentScrollTop = containerElem.scrollTop();
            shouldScroll = containerElem[0].scrollHeight - currentScrollTop
            - containerElem.outerHeight() < containerElem.outerHeight() * scrollDistance;
            var scrollDown = tempScrollTop < currentScrollTop;    // find scroll direction
            tempScrollTop  = currentScrollTop;
            shouldScroll = shouldScroll && scrollDown;
          } else {
            // global behavior - calculate relative to the browser window height
            var elementBottom, remaining, windowBottom;
            windowBottom  = $window.height()  + $window.scrollTop();
            elementBottom = containerElem.offset().top + containerElem.height();
            remaining = elementBottom - windowBottom;
            shouldScroll = remaining <= $window.height() * scrollDistance;
          }

          if (shouldScroll && scrollEnabled) {
            return $rootScope.$$phase ? scope.$eval(attrs.infiniteScroll) :
                                        scope.$apply(attrs.infiniteScroll);
          } else if (shouldScroll) {
            return checkWhenEnabled = true;
          }
        };

        (useContainerElem ? containerElem : $window).on('scroll', handler);

        scope.$on('$destroy', function() {
          return (useContainerElem ? containerElem : $window).off('scroll', handler);
        });

        return $timeout((function() {
          if (attrs.infiniteScrollImmediateCheck) {
            if (scope.$eval(attrs.infiniteScrollImmediateCheck)) {
              return handler();
            }
          } else {
            return handler();
          }
        }), 0);
      }
    };
  }
]);
